import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { debug } from 'console';
import { FileTypeT3 } from 'src/app/core/enums/user/file-type';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { SelfAssessmentCkDataSaveModel } from 'src/app/core/models/self-assessmentT2/update-self-assessmentT2-model';
import { SelfAssessmentJudgement } from 'src/app/core/models/self-assessmentT3/SelefassessmentJudgement';
import { SelfAssessmentT3ApproachDto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentApproach';
import {
  SelfAssessmentInterpretation,
  userDropdownDto,
} from 'src/app/core/models/self-assessmentT3/SelfAssessmentInterpretation';
import { rightsManagementSAT3Dto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3Filter';
import { SelfAssessmentCkDataSaveT3Dto } from 'src/app/core/models/self-assessmentT3/overall-aseesment';
import { overallAssessmentDropdownList } from 'src/app/core/models/self-assessmentT3/overallDropdownList';
import {
  ApproachAssessmentDto,
  interpretationAssessmentDto,
  judgementAssessmentDto,
} from 'src/app/core/models/self-assessmentT3/saveDataModel';
import {
  VersionFilterViewT3Model,
  VersionHistoryT3DataDto,
} from 'src/app/core/models/self-assessmentT3/version-filter-viewT3-model';
import { ckEditorBroadcastMessage } from 'src/app/core/models/signalR/ckEditorBroadcastMessage';
import { UserProfile } from 'src/app/core/models/user';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { GlobalService } from 'src/app/core/services/global/global.service';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import { MasterHelper } from 'src/app/core/utilities';
import { ModalDialogComponent } from 'src/app/views/distributed-ui-components/modal-dialog/modal-dialog.component';
import { SelfAssessmentDialogComponent } from 'src/app/views/self-assessment/self-assessment-dialog/self-assessment-dialog.component';
import { CkEditorRevisionComponent } from 'src/app/views/shared/ck-editor-revision/ck-editor-revision.component';

@Component({
  selector: 'app-front',
  templateUrl: './front.component.html',
  styleUrls: ['./front.component.scss'],
})
export class FrontComponent implements OnInit {
  @Input() summaryDetailsId: number = 0;
  @Input() assessmentSummaryDetailsId: string = '';
  @Input() user: UserProfile = new UserProfile();
  @Input() selfAssessmentDocument: SelfAssessmentDocumentModel[] = [];
  @Input() tab!: number;
  @Input() versionHistoryData!: VersionHistoryT3DataDto;
  @Input() JudgmentList: SelfAssessmentJudgement;
  @Input() tabName: string = '';
  @Input() interpretationAssessmentDropdownList: overallAssessmentDropdownList =
    new overallAssessmentDropdownList();
  @Output() onChildVariableChangeInterpretationT3: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() onEditorSaveInterPretationT3: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() handleFileInputMainT3: EventEmitter<any> = new EventEmitter<any>();
  @Output() reviewCompSet: EventEmitter<any> = new EventEmitter<any>();
  mainEvidanceLoader: boolean = false;
  isLoading: boolean = true;
  toastModel: ToastViewModel = new ToastViewModel();
  isToastShow: boolean = false;
  @ViewChild('uploadEvidanceT3') uploadEvidanceT3: any;
  @ViewChildren(CkEditorRevisionComponent) ckEditorComponent:
    | QueryList<CkEditorRevisionComponent>
    | undefined;

  @Input() assessmentData!: any;
  isButtonDisabled: boolean = false;
  @Output() parentDataChange = new EventEmitter<any>();
  @Output() afterSave = new EventEmitter<void>();
  private _childData!: any;
  get childData(): any {
    return this._childData;
  }
  set childData(value: any) {
    this._childData = value;
    this.parentDataChange.emit(value);
  }
  isSaveButtonClicked: boolean = false;
  submitterList: userDropdownDto[] = [];
  constructor(
    private _selfAssessment3Service: SelfAssessmentTemplate3Service,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private _signalRService: SignalRService,
    private _globalService: GlobalService
  ) {
    this.JudgmentList = new SelfAssessmentJudgement();
  }
  userPermissionList!: rightsManagementSAT3Dto | undefined;
  async ngOnInit() {
    this._globalService.submitterDropdownVariable$.subscribe(() => {
      this.filterSubmitterNameDropdown(); // dropdown options being assigned
    });
    this.filterSubmitterNameDropdown();
    this.userPermissionList = await this._globalService.getUserPermissionList(
      this.assessmentData.id,
      this.versionHistoryData.isVersonHistory,
      this.user,
      this.assessmentData.summaryDetailsId,
      this.tabName
    );
  }
  //ckeditor save
  async onChildVariableChangeMainT3(data: any, type: string) {
    if (type == 'InterpretationDetails') {
      this.assessmentData.interpretationDetails = data;
      this.assessmentData.muteInterpretationDetailsUsers = this.updateUserList(
        this.assessmentData.muteInterpretationDetailsUsers,
        this.user.fullName
      );
    } else if (type == 'ImplementationComments') {
      this.assessmentData.implementationComments = data;
      this.assessmentData.muteImplementationCommentsUsers = this.updateUserList(
        this.assessmentData.muteImplementationCommentsUsers,
        this.user.fullName
      );
    } else if (type == 'JudgementDetails') {
      this.assessmentData.judgementDetails = data;
      this.assessmentData.muteJudgementDetailsUsers = this.updateUserList(
        this.assessmentData.muteJudgementDetailsUsers,
        this.user.fullName
      );
    } else if (type == 'JudgementImplementationComments') {
      this.assessmentData.judgementImplementationComments = data;
      this.assessmentData.muteJudgementImplementationCommentsUsers =
        this.updateUserList(
          this.assessmentData.muteJudgementImplementationCommentsUsers,
          this.user.fullName
        );
    } else if (type == 'ApproachDetails') {
      this.assessmentData.approachDetails = data;
      this.assessmentData.muteApproachDetailsUsers = this.updateUserList(
        this.assessmentData.muteApproachDetailsUsers,
        this.user.fullName
      );
    } else if (type == 'ApproachImplementationComments') {
      this.assessmentData.approachImplementationComments = data;
      this.assessmentData.muteApproachImplementationCommentsUsers =
        this.updateUserList(
          this.assessmentData.muteApproachImplementationCommentsUsers,
          this.user.fullName
        );
    }
    this.ref.detectChanges();
  }
  updateUserList(userlist: string, newUser: string): string {
    if (userlist) {
      const userList: string[] = userlist.split(',');
      const isPresent: boolean = userList.includes(newUser);
      if (!isPresent) {
        userList.push(newUser);
      }
      userlist = userList.join(',');
    } else {
      userlist = newUser;
    }
    return userlist;
  }
  onEditorSaveMainT3(data: SelfAssessmentCkDataSaveModel) {
    let payloadData: SelfAssessmentCkDataSaveT3Dto =
      new SelfAssessmentCkDataSaveT3Dto(
        data.ckData,
        data.ckName,
        data.selfAssessmentT2Id,
        this.assessmentData.id,
        data.userName
      );
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .updateSelfAssessmentCKForInterpretationT3(payloadData)
        .subscribe((res: any) => {
          this.alertMessage('success', ' Saved successfully');
          setTimeout(() => { }, 3500);
          this.notifyParentCkEditorChnage();
        });
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .updateSelfAssessmentCKForJudgementT3(payloadData)
        .subscribe((res: any) => {
          this.alertMessage('success', ' Saved successfully');
          setTimeout(() => { }, 3500);
          this.notifyParentCkEditorChnage();
        });
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .updateSelfAssessmentCKForApproachT3(payloadData)
        .subscribe((res: any) => {
          this.alertMessage('success', ' Saved successfully');
          setTimeout(() => { }, 3500);
          this.notifyParentCkEditorChnage();
        });
    }
  }
  //upload evidance
  uploadEvidenceMain() {
    if (this.userPermissionList?.UplEvdAssessment) {
      const fileInput = document.getElementById(
        'uploadEvidanceT3'
      ) as HTMLElement;
      fileInput.click();
    }
  }
  handleFileInput(files: FileList) {
    if (this.tabName == 'Interpretation') {
      for (let i = 0; i < files.length; i++) {
        this.uploadFileToActivity(files[i], FileTypeT3.Interpretation);
      }
    } else if (this.tabName == 'Judgement') {
      for (let i = 0; i < files.length; i++) {
        this.uploadFileToActivity(files[i], FileTypeT3.JudgementAssessment);
      }
    } else if (this.tabName == 'Approach') {
      for (let i = 0; i < files.length; i++) {
        this.uploadFileToActivity(files[i], FileTypeT3.ApproachAssessment);
      }
    }
  }
  uploadFileToActivity(fileToUpload: any, fileType: FileTypeT3) {
    this.mainEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .UploadEvidenceInterpretationT3(
          fileToUpload,
          fileType,
          this.assessmentData.id.toString()
        )
        .subscribe(
          (data: any) => {
            this.fetchSelfAssessmentDocuments(fileType);
            this.mainEvidanceLoader = false;
          },
          (err: HttpErrorResponse) => {
            this.alertMessage(
              'warning',
              'File not uploaded, please check your file'
            );
            setTimeout(() => { }, 3500);
          }
        );
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .UploadEvidenceJudgementT3(
          fileToUpload,
          fileType,
          this.assessmentData.id.toString()
        )
        .subscribe(
          (data: any) => {
            this.fetchSelfAssessmentDocuments(fileType);
            this.mainEvidanceLoader = false;
          },
          (err: HttpErrorResponse) => {
            this.alertMessage(
              'warning',
              'File not uploaded, please check your file'
            );
            setTimeout(() => { }, 3500);
          }
        );
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .UploadEvidenceApproachT3(
          fileToUpload,
          fileType,
          this.assessmentData.id.toString()
        )
        .subscribe(
          (data: any) => {
            this.fetchSelfAssessmentDocuments(fileType);
            this.mainEvidanceLoader = false;
          },
          (err: HttpErrorResponse) => {
            this.alertMessage(
              'warning',
              'File not uploaded, please check your file'
            );
            setTimeout(() => { }, 3500);
          }
        );
    }
  }
  fetchSelfAssessmentDocuments(fileType: FileTypeT3): void {
    this.mainEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .getSelfAssessmentT3InterpretationDocument(this.assessmentData.id)
        .subscribe((result: SelfAssessmentDocumentModel[]) => {
          this.selfAssessmentDocument = result;
          this.mainEvidanceLoader = false;
        });
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .getSelfAssessmentT3JudgementDocument(this.assessmentData.id)
        .subscribe((result: SelfAssessmentDocumentModel[]) => {
          this.selfAssessmentDocument = result;
          this.mainEvidanceLoader = false;
        });
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .getSelfAssessmentT3ApproachDocument(this.assessmentData.id)
        .subscribe((result: SelfAssessmentDocumentModel[]) => {
          this.selfAssessmentDocument = result;
          this.mainEvidanceLoader = false;
        });
    }
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }
  openDeleteModel(id: number): void {
    if (this.userPermissionList?.UplEvdAssessment) {
      const dialogRef = this.dialog.open(ModalDialogComponent, {
        data: {
          message: 'Are you sure want to delete?',
          title: 'Delete Document',
          btnText: 'Delete',
        },
      });
      dialogRef.afterClosed().subscribe((data: any) => {
        if (data) {
          this.removeSelfAssessmentDocumentsT3(id);
        }
      });
    }
  }
  removeSelfAssessmentDocumentsT3(id: number) {
    this.mainEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .deleteSelfAssessmentInterpretationT3Document(id)
        .subscribe((data: any) => {
          if (data.result) {
            this.mainEvidanceLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.Interpretation);
            this.alertMessage('success', data.result);
          }
        });
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service
        .deleteSelfAssessmentJudgementT3Document(id)
        .subscribe((data: any) => {
          if (data.result) {
            this.mainEvidanceLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.JudgementAssessment);
            this.alertMessage('success', data.result);
          }
        });
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service
        .deleteSelfAssessmentApproachT3Document(id)
        .subscribe((data: any) => {
          if (data.result) {
            this.mainEvidanceLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.ApproachAssessment);
            this.alertMessage('success', data.result);
          }
        });
    }
  }
  downloadDocument(id: number, fileName: string, extension: string) {
    this.mainEvidanceLoader = true;
    if (this.tabName == 'Interpretation') {
      this._selfAssessment3Service
        .downloadEvidenceInterpretationT3(id)
        .subscribe(
          (data: any) => {
            this._globalService.downloadDocument(data, fileName, extension);
            this.mainEvidanceLoader = false;
          },
          (err: HttpErrorResponse) => {
            console.error(JSON.stringify(err.message));
          }
        );
    } else if (this.tabName == 'Judgement') {
      this._selfAssessment3Service.downloadEvidenceJudgementT3(id).subscribe(
        (data: any) => {
          this._globalService.downloadDocument(data, fileName, extension);
          this.mainEvidanceLoader = false;
        },
        (err: HttpErrorResponse) => {
          console.error(JSON.stringify(err.message));
        }
      );
    } else if (this.tabName == 'Approach') {
      this._selfAssessment3Service.downloadEvidenceApproachT3(id).subscribe(
        (data: any) => {
          this._globalService.downloadDocument(data, fileName, extension);
          this.mainEvidanceLoader = false;
        },
        (err: HttpErrorResponse) => {
          console.error(JSON.stringify(err.message));
        }
      );
    }
  }
  //global save
  async editorSave() {
    if (this.ckEditorComponent) {
      for (const editor of this.ckEditorComponent) {
        if (editor?.buttonActive) {
          await editor?.CalledUpdatedSelfAssessmentData();
        }
      }
    }
    this.saveAImplementationAssessmentDataWithDataChange();
  }
  async saveImplementationAssessmentData() {
    this.isButtonDisabled = true;
    await this.editorSave();
  }
  async saveAImplementationAssessmentDataWithDataChange() {
    const currentUrl = window.location.href;
    this.assessmentData.implementationDate = this.assessmentData
      .implementationDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.assessmentData.implementationDate.toString()
      )
      : null;
    if (this.tabName == 'Interpretation') {
      let interpretation: SelfAssessmentInterpretation = this.assessmentData;
      let data: interpretationAssessmentDto = new interpretationAssessmentDto(
        interpretation
      );
      this.saveInterpretationT3AssessmentData(data, currentUrl);
    } else if (this.tabName == 'Judgement') {
      let judgement: SelfAssessmentJudgement = this.assessmentData;
      let data: judgementAssessmentDto = new judgementAssessmentDto(judgement);
      this.saveJudgementT3AssessmentData(data, currentUrl);
    } else if (this.tabName == 'Approach') {
      const approach: SelfAssessmentT3ApproachDto = this.assessmentData;
      const data: ApproachAssessmentDto = new ApproachAssessmentDto(approach);
      this.saveApproach3AssessmentData(data, currentUrl);
    }
  }
  saveInterpretationT3AssessmentData(
    data: interpretationAssessmentDto,
    currentUrl: string
  ) {
    this._selfAssessment3Service
      .saveInterpretationT3AssessmentData(data, currentUrl)
      .subscribe((x) => {
        this.alertMessage('success', 'Interpretation saved successfully');
        setTimeout(async () => {
          this.userPermissionList =
            await this._globalService.getUserPermissionList(
              this.assessmentData.id,
              this.versionHistoryData.isVersonHistory,
              this.user,
              this.assessmentData.summaryDetailsId,
              this.tabName
            );
        }, 3500);
        this.isButtonDisabled = false;
        this.afterSave.emit();
      });
  }
  saveJudgementT3AssessmentData(
    data: judgementAssessmentDto,
    currentUrl: string
  ) {
    this._selfAssessment3Service
      .saveJudgementT3AssessmentData(data, currentUrl)
      .subscribe(async (x) => {
        this.alertMessage('success', 'Judgement saved successfully');
        setTimeout(async () => {
          this.userPermissionList =
            await this._globalService.getUserPermissionList(
              this.assessmentData.id,
              this.versionHistoryData.isVersonHistory,
              this.user,
              this.assessmentData.summaryDetailsId,
              this.tabName
            );
        }, 3500);
        this.isButtonDisabled = false;
        this.afterSave.emit();
      });
  }
  saveApproach3AssessmentData(data: ApproachAssessmentDto, currentUrl: string) {
    this._selfAssessment3Service
      .saveApproach3AssessmentData(data, currentUrl)
      .subscribe(async (x) => {
        this.alertMessage('success', 'Approach saved successfully');
        setTimeout(async () => {
          this.userPermissionList =
            await this._globalService.getUserPermissionList(
              this.assessmentData.id,
              this.versionHistoryData.isVersonHistory,
              this.user,
              this.assessmentData.summaryDetailsId,
              this.tabName
            );
        }, 3500);
        this.isButtonDisabled = false;
        this.afterSave.emit();
      });
  }
  @Output() notifyCkEditorChnage: EventEmitter<any> = new EventEmitter<any>();
  notifyParentCkEditorChnage() {
    this.notifyCkEditorChnage.emit();
  }

  openDialog(tabName: string): void {
    const filterDataModel = new VersionFilterViewT3Model();
    filterDataModel.interpretationId = this.assessmentData.id;
    filterDataModel.filterType = 'version';
    filterDataModel.templateId = 3;
    filterDataModel.versionType = tabName;
    filterDataModel.summuryDetailsId = this.assessmentSummaryDetailsId;
    filterDataModel.tab = this.tab;
    const dialogRef = this.dialog.open(SelfAssessmentDialogComponent, {
      data: filterDataModel,
      width: '750px',
    });
    dialogRef.afterClosed().subscribe(() => { });
  }
  @Output() isReadyForReviewChanged = new EventEmitter<void>();
  async isReadyForReviewClicked(event: any) {
    if (event.target.checked) {
      await this.isReadyForReviewChanged.emit(event.target.checked);
    } else {
      if (
        this.assessmentData.conditionalApproval ||
        this.assessmentData.readyForApproval
      ) {
        // this.assessmentData.readyForReview = true;
        event.preventDefault();
        event.stopPropagation();
        this.ref.detectChanges();
        this.alertMessage(
          'warning',
          'You need to disable Ready For Approval and Conditional Approval'
        );
      } else {
        await this.isReadyForReviewChanged.emit(event.target.checked);
      }
    }
  }
  onSelectionChange(value: any) {
    this._globalService.selectedSubmitterName = value;
    this._globalService.setReviewDropdownVariable();
    //this._globalService.setAppprovDropdownVariable();
    //this._globalService.setCondApproveDropdownVariable();
  }
  filterSubmitterNameDropdown() {
    this.submitterList = this.interpretationAssessmentDropdownList.submitterNameList;
    this._globalService.selectedSubmitterName = this.assessmentData.submitterName;
    const nameFilterList = this.assessmentData.reviewerName?.split(',')?.map((x: string)=>{
      return {
        name: x,
        value: x,
        geography: null
      }
    });
    const approversFilterList = this.assessmentData.approvers?.split(',')?.map((x: string)=>{
      return {
        name: x,
        value: x,
        geography: null
      }
    });
    const actionOwnerFilterList = this.assessmentData.actionOwner?.split(',')?.map((x: string)=>{
      return {
        name: x,
        value: x,
        geography: null
      }
    });
    const selectedReviewerName = (this._globalService.selectedReviewerName && this._globalService.selectedReviewerName.length > 0) ? this._globalService.selectedReviewerName : nameFilterList;
    const selectedApproverName = (this._globalService.selectedApproverName && this._globalService.selectedApproverName.length > 0) ? this._globalService.selectedApproverName : approversFilterList;
    const selectedCondApproverName = this._globalService.selectedCondApproverName && this._globalService.selectedCondApproverName.length > 0 ? this._globalService.selectedCondApproverName : actionOwnerFilterList;
    if (selectedReviewerName && selectedReviewerName.length > 0) {
      this.submitterList = this.submitterList.filter((obj: userDropdownDto) =>
        !selectedReviewerName.some((filterObj: userDropdownDto) => filterObj.value === obj.value // all dropdownn when there is some value is selected
        )
      );
    }
    if (selectedApproverName && selectedApproverName.length > 0) {
      this.submitterList = this.submitterList.filter((obj: userDropdownDto) =>
        !selectedApproverName.some((filterObj: userDropdownDto) => filterObj.value === obj.value // all dropdownn when there is some value is selected
        )
      );
    }
    if (selectedCondApproverName && selectedCondApproverName.length > 0) {
      this.submitterList = this.submitterList.filter((obj: userDropdownDto) =>
        !selectedCondApproverName.some((filterObj: userDropdownDto) => filterObj.value === obj.value // all dropdownn when there is some value is selected
        )
      );
    }
  }
}
